import PropTypes from 'prop-types';
import React from 'react';
import ListItemCreated from 'shared/_components/list/list-item-created';

const EpisodeListItemDetails = ({ item }) => (
    <>
        <ListItemCreated key="created" value={item.created} />
    </>
);
EpisodeListItemDetails.propTypes = {
    item: PropTypes.shape({
        created: PropTypes.string,
    }),
};

export default EpisodeListItemDetails;
